// The category taxonomy as the website reads it (wave 13, pillar 9): compiled into categories-data.ts by
// `bun catalogue/scripts/categories.ts` from catalogue/taxonomy/categories.json. The launcher reads the same lists from
// catalogue/data/categories.json.

import { CATEGORIES } from "../categories-data.ts";

export interface Category {
  id: string;
  title: string;
  line: string;
  /** the archetype persona who programs the world */
  curator: string;
  /** the zone that is this category's world, once built */
  zone: string | null;
  /** "featured" (a language, a controller, all ages), or null for a genre world */
  group: string | null;
  /** accounts row ids (Discover's themed rows) that open this world */
  discoverRows: string[];
  /** catalogue genres that are wholly this category */
  genres: string[];
  /** every game, most popular first */
  games: string[];
  /** games with an outside popularity signal, highest first */
  popular: string[];
  /** the one source of `popular`'s signal ("x", "foundplay"), else null */
  popularSource: string | null;
  subcategories: { id: string; title: string; line: string | null; games: string[] }[];
  feature: { id: string; title: string; blurb: string; art: string | null; creator: string; url: string } | null;
}

export function allCategories(): readonly Category[] {
  return CATEGORIES;
}

export function categoryById(id: string | undefined): Category | undefined {
  return id ? CATEGORIES.find((c) => c.id === id) : undefined;
}

/** The world a Discover row opens, if its category has one. */
export function categoryForRow(rowId: string): Category | undefined {
  return CATEGORIES.find((c) => c.zone && c.discoverRows.includes(rowId));
}
